export const STORAGE_KEYS = Object.freeze({
  TOKEN: '__TOKEN',
  PATIENT_MAIN_UNIQUE: '__PATIENT_MAIN_UNIQUE',
  LANGUAGE_KEY: '__LANGUAGE_KEY',
  PUSH_FCM_TOKEN: '__PUSH_FCM_TOKEN',
  PUSH_INSTALLATION_ID: '__PUSH_INSTALLATION_ID',
  // Followed by the patient's OMRON group tag; present while a device is paired.
});

export const LOCALE = Object.freeze({
  ENGLISH: 'en',
  CHINESE: 'zh',
});

export const DEFAULT_LOCALE = LOCALE.ENGLISH;

export const APP_TAB = Object.freeze({
  HOME: 'home',
  FLUID: 'fluid',
  SYMPTOMS: 'symptoms',
  DIET: 'diet',
  MORE: 'more',
});

export const LANGUAGE_OPTIONS = Object.freeze([
  {
    code: LOCALE.ENGLISH,
    name: 'English',
    nativeName: 'English',
    shortName: 'EN',
    translationKey: 'languages.en',
  },
  {
    code: LOCALE.CHINESE,
    name: 'Chinese',
    nativeName: '中文',
    shortName: '中文',
    translationKey: 'languages.zh',
  },
]);
